import styled from 'styled-components';


export const userOptions = (params = {}) => ({
  header: params.header,
  data: params.data,
});

//  标题a
export const ModuleTitle = styled.h3`
  padding: 1.125rem 1.125rem;
  color: #bcdcff;
  font-size: 1.2rem;
  font-weight: bold;
  .iconfont {
    font-size: 0.175rem;
    margin-right: 0.125rem;
    color: #89e5ff;
    font-weight: 400;
  }
`;
